import RuleConfig from '../../model/ruleConfig'
import { LimitBuyCouponRuleConfig } from './limitBuyCouponRuleConfig'
import { BuyGetCouponRuleConfig } from './buyGetCouponRuleConfig'
import { HelpGetCouponRuleConfig } from './helpGetCouponRuleConfig'
import { NewComerGiftPackRuleConfig } from './newComerGiftPackRuleConfig'
import { QuestionnaireGetCouponRuleConfig } from './questionnaireGetCouponRuleConfig'
export default function getRuleConfig(type: string): RuleConfig {
  if (type === 'buyGetCoupon') {
    let config: BuyGetCouponRuleConfig = {
      memberScope: 'All',
      memberTags: [],
      cumulativeWithOtherDiscount: false,
      discounts: [],
      discountType: 0,
      value: 0,
      coupons: []
    }
    return config
  } else if (type === 'limitBuyCoupon') {
    let config: LimitBuyCouponRuleConfig = {
      memberScope: 'All',
      memberTags: [],
      cumulativeWithOtherDiscount: false,
      discounts: [],
      coupons: []
    }
    return config
  } else if (type === 'helpGetCoupon') {
    let config: HelpGetCouponRuleConfig = {
      memberScope: 'All',
      memberTags: [],
      cumulativeWithOtherDiscount: false,
      freeCoupons: [],
      discounts: [],
      duration: 0,
      helpCount: 0,
      coupons: []
    }
    return config
  } else if (type === 'newComerGiftPack') {
    let config: NewComerGiftPackRuleConfig = {
      memberScope: 'All',
      memberTags: [],
      cumulativeWithOtherDiscount: false,
      discounts: [],
      coupons: []
    }
    return config
  } else if (type === 'questionnaireGetCoupon') {
    let config: QuestionnaireGetCouponRuleConfig = {
      memberScope: 'All',
      memberTags: [],
      cumulativeWithOtherDiscount: false,
      discounts: [],
      coupons: []
    }
    return config
  } else if (type === 'grabCoupon') {
    let config: LimitBuyCouponRuleConfig = {
      memberScope: 'All',
      memberTags: [],
      cumulativeWithOtherDiscount: false,
      discounts: [],
      coupons: []
    }
    return config
  } else {
    let config: RuleConfig = {
      memberScope: 'All',
      memberTags: [],
      cumulativeWithOtherDiscount: false,
      discounts: []
    }
    return config
  }
}
